<!-- Modal Card: Diseñado sin Bootstrap -->
<!--
<div class="bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.15)] w-full max-w-md p-14 flex flex-col items-center text-center animate-in fade-in zoom-in duration-300">
  <div class="mb-10 flex flex-col items-center select-none">
    <img id="tower-img" class="login-logo" [src]="logoUrl" />
  </div>
  <div class="loading-screen-icon">
    <mat-spinner></mat-spinner>
      <span>Connecting with the custodian...</span>
  </div>
</div>
-->
<div class="container-login">
  <mat-card class="login-card">
        <img id="tower-img" class="login-logo" [src]="logoUrl" />
        <div >
          <span class="texto">Connecting with the custodian...</span>
          <mat-spinner></mat-spinner>
        </div>
  </mat-card>
</div>
